import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { CasdoorAuthService } from 'app/core/auth/casdoor-auth.service';
import { catchError, of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(CasdoorAuthService);
    console.log('AuthGuard state:', state);

    return authService.isAuthenticated$.pipe(
        switchMap((authenticated) => {
            console.log('AuthGuard authenticated:', authenticated);
            if (!authenticated) {
                const redirectURL = `redirectURL=${encodeURIComponent(state.url)}`;
                console.log('Redirect URL:', redirectURL);
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
                return of(urlTree);
            }
            return of(true);
        }),
        catchError((error) => {
            console.error('AuthGuard error:', error);
            return of(router.parseUrl('sign-in'));
        })
    );
};